var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex"}},_vm._l((_vm.rgStockReports),function(report){return _c('rack-group-stock-report',{key:report.id,attrs:{"rg-stock-report":report}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }